import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "available_days",
        object: "available_day",
        header: [
            { text: "Día", value: "day" },
            { text: "Horarios", value: "available_hours" },
            { text: "Disponibilidad", value: "availability" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
